module.exports = __webpack_public_path__ + "CCicon.png?445c9a617d0b590ba48002cf4f10a8e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CCicon.png
// module id = 34
// module chunks = 0